export default __webpack_public_path__ + "static/media/logo.ac8b33a5.png";